import React from 'react';
import '../../../styles/About.scss';
import Arrow from "../../../common_components/design_components/Arrow";
import CmykFull from "../../../common_components/design_components/CmykFull";
import Mark from '../../../common_components/design_components/Mark';

const AboutDesktop = () => {
  return (
    <div className="about-page">
      {/* Left Section */}
      <div className="about-left">
        <h1 className="about-title">
          ABOUT
        </h1>
        <div className="arrow-container">
          <Arrow />
        </div>
        <CmykFull />
      </div>

      {/* Right Section */}
      <div className="about-right">
        <div className="about-text">
          <p>
            <em>
              Hi, I'm Jacob—a web developer, graphic designer, and practicing
              artist with a passion for creativity and problem-solving. Over the
              years, I've combined technical expertise with artistic vision to
              craft solutions that look great and work even better. Whether I'm
              coding a responsive web application, designing an engaging user
              experience, or painting in my studio, I thrive on ideation and
              bringing fresh ideas to life.
            </em>
          </p>
          <p>
            <em>
              I approach every project with an open mind because no two
              challenges are the same. Each project deserves a tailored
              solution, informed by its unique goals, merits, and obstacles.
            </em>
          </p>
          <p>
            <em>
              If you're looking for someone who combines creativity, technical
              skill, and a people-first approach, I'd love to collaborate with
              you. Let's create something amazing together!
            </em>
          </p>
        </div>
      </div>
      <div className="registration-mark top-left">
        <Mark />
      </div>
      <div className="registration-mark bottom-left">
        <Mark />
      </div>
    </div>
  );
};

export default AboutDesktop

